import { useMemo } from 'react'

import { safeJsonParsing } from '../../../common/safeJsonParsing'
import { usePriceEstimateSelectBoxQuery } from '../../../graphql/generated'
import { useAppSelector } from '../../../redux/hooks'
import { MonitNode } from '../PriceEstimateSelectBox/PriceEstimateSelectBox'

type MonitRequestData = {
  monit_object?: {
    pl_uzitna?: number
    pl_celkova?: number
    pl_pozemku?: number
    dispozice_mistnosti?: number
    prislusenstvi_fl?: number
    druh_konstrukce?: number
  }
}

export type ParsedPriceEstimate = {
  estimateToDate?: string
  cenaReal?: number
  monit_object?: MonitRequestData['monit_object']
}

export const useBuybackPriceEstimates = () => {
  const tenantId = useAppSelector(state => state.myProfile.tenantId)
  const propertyId =
    useAppSelector(state => state.property.ruian.data?.id) || ''

  const [queryResult] = usePriceEstimateSelectBoxQuery({
    pause: !propertyId,
    variables: { accountId: tenantId, propertyId },
  })

  const priceEstimates = useMemo(
    () =>
      (queryResult.data?.allMonits?.nodes || []).filter(
        (estimate): estimate is MonitNode => !!estimate
      ),
    [queryResult.data?.allMonits?.nodes]
  )

  const priceEstimatesParsed = useMemo(() => {
    const map = new Map<string, ParsedPriceEstimate>()
    for (const estimate of priceEstimates) {
      if (!estimate) continue
      const parsed = safeJsonParsing<MonitRequestData | null>(
        estimate?.requestData,
        null
      )
      map.set(String(estimate.id), {
        cenaReal: Number(estimate?.cenaReal) || 0,
        monit_object: parsed?.monit_object,
        estimateToDate: String(estimate?.estimateToDate || ''),
      })
    }
    return map
  }, [priceEstimates])

  return {
    priceEstimates,
    priceEstimatesParsed,
    loading: queryResult.fetching,
  }
}
